import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left-arrow-thick-accent",
  "use": "left-arrow-thick-accent-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"left-arrow-thick-accent\">\n    <path fill=\"#03ADEF\" fill-rule=\"evenodd\" stroke=\"#03ADEF\" d=\"M7.957 2.6l.707.707-5.158 5.156 12.95.001v1l-12.95-.001 5.158 5.158-.707.707-6.01-6.01c-.196-.196-.196-.512 0-.708l6.00001-6.01z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol